import React from 'react'
import './miMensajes.css'
import { MiFooter } from '../../components/footer/MiFooter';
import { ContentMiMensajes } from '../../components/mensajes/ContentMiMensajes';
import { useContext } from 'react'
import { UsuarioContext } from '../../contexts/UsuarioContext'
import HeaderHome from '../../components/headerHome/HeaderHome';

export const Mensajes = () => {

  const [MenuLateral, setMenuLateral] = useContext(UsuarioContext)
  const closeMenu = () => {
    if (MenuLateral === true) {
      setMenuLateral(false)
    }
  }
  return (
    <div className='miMensajes' onClick={closeMenu} >
      <div className='headerMensajes'>
        <HeaderHome />
      </div>
      <div className="bodyMensajes">
        <ContentMiMensajes />
      </div>
      <div className='footerMensajes'>
        <MiFooter />
      </div>
    </div>
  )
}
